/**
 * /about — provenance and background.
 *
 * The Provenance strip originally sat on the landing page. It was moved here so
 * the front page stays a catalogue: a visitor arriving from a dataset search
 * wants coverage figures, not a founder bio. The credentials still matter for
 * diligence, they just belong on the page someone visits deliberately.
 *
 * Everything rendered here comes from Provenance.tsx — see that file's header
 * for the rules governing which claims may appear (no founding year, no client
 * claims, links only where the URL is known).
 */
import React from 'react';
import AppBar from 'app/components/Layout/AppBar';
import Footer from 'app/components/Footer';
import { SmoothScroll } from 'app/components/SmoothScroll';
import { Provenance } from 'app/components/Landing/Provenance';
import { Seo } from 'app/components/Seo';

export function AboutPage() {
  return (
    <SmoothScroll>
      <div className="relative bg-transparent overflow-hidden">
        <Seo
          title="About"
          description="Sov.ai is an ML data lab and Python SDK for institutional investors. Infrastructure started 2021; first client deliveries 2023. Founded by Derek Snow, Assistant Industry Professor at New York University."
          path="/about"
        />

        <AppBar />

        <main className="min-h-screen pt-20 pb-16">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <header className="mb-10">
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-gray-400">
                About
              </p>
              <h1 className="mt-3 text-3xl md:text-4xl font-bold text-white">
                Who builds the catalogue
              </h1>
              <p className="mt-4 max-w-2xl text-gray-300">
                Sov.ai is an ML data lab and Python SDK for institutional
                investors. Infrastructure started 2021; first client deliveries
                2023.
              </p>
            </header>

            <Provenance />
          </div>
        </main>

        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default AboutPage;
